import React, { useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", comment: "" });
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!form.email || !form.comment) { setErr("Email and comment are required"); return; }
    // Form is illustrative — real contact submission deferred to Phase 11 (SendGrid/Resend).
    setSent(true); setErr("");
  };

  return (
    <div data-testid="contact-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
      <div>
        <div className="eyebrow">Contact</div>
        <h1 className="font-anton text-4xl sm:text-5xl uppercase mt-2 leading-[0.95]">Get in touch</h1>
        <p className="text-lifted-dim mt-3">Questions about an order, a partnership, the affiliate program, or anything else? Drop us a line — we read everything.</p>

        <ul className="mt-8 space-y-4 text-sm">
          <li className="flex items-start gap-3"><Mail className="h-4 w-4 text-lifted-green mt-1" />
            <div><div className="font-anton uppercase text-base">Email</div><div className="text-lifted-dim">hello@liftedatthemoment.com</div></div>
          </li>
          <li className="flex items-start gap-3"><Phone className="h-4 w-4 text-lifted-green mt-1" />
            <div><div className="font-anton uppercase text-base">Phone</div><div className="text-lifted-dim">By appointment — message first</div></div>
          </li>
          <li className="flex items-start gap-3"><MapPin className="h-4 w-4 text-lifted-green mt-1" />
            <div><div className="font-anton uppercase text-base">Operations</div><div className="text-lifted-dim">Same-day delivery zones — see Lifted Supplies for availability</div></div>
          </li>
        </ul>
      </div>

      <form onSubmit={submit} className="glass-panel p-6 sm:p-8 space-y-3" data-testid="contact-form">
        <div className="eyebrow !text-lifted-text-dim">Contact form</div>
        <input data-testid="contact-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Name" className="input-lifted text-sm w-full" />
        <input data-testid="contact-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email *" type="email" required className="input-lifted text-sm w-full" />
        <input data-testid="contact-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone number" className="input-lifted text-sm w-full" />
        <textarea data-testid="contact-comment" value={form.comment} onChange={(e) => setForm({ ...form, comment: e.target.value })} placeholder="Comment *" rows={5} required className="input-lifted text-sm w-full" />
        {err && <div className="text-rose-300 text-xs" data-testid="contact-error">{err}</div>}
        <button type="submit" disabled={sent} className="btn-lifted w-full" data-testid="contact-send">
          {sent ? "Sent ✓ — we'll get back to you" : "Send"}
        </button>
        <p className="text-[0.6rem] text-lifted-mute">Live email delivery wires up in Phase 11. For urgent help, email us directly.</p>
      </form>
    </div>
  );
}
